module.exports = __webpack_public_path__ + "static/media/facebook-f-brands.cf956850.svg";